import { defineSelectorFactory } from '@exodus/redux-dependency-injection';
import { createSelector } from 'reselect';
const getExportPathNameSelectorFactory = (getWalletAccountSelector, getPathFriendlyNameSelector) => createSelector(getWalletAccountSelector, getPathFriendlyNameSelector, (getWalletAccount, getWalletAccountPathFriendlyName) => (walletAccount) => {
    const { isHardware } = getWalletAccount(walletAccount) ?? {};
    return isHardware ? getWalletAccountPathFriendlyName(walletAccount) : walletAccount;
});
const getExportPathNameSelectorDefinition = defineSelectorFactory({
    id: 'getExportPathName',
    selectorFactory: getExportPathNameSelectorFactory,
    dependencies: [
        { selector: 'get' },
        { selector: 'getPathFriendlyName' },
    ],
});
export default getExportPathNameSelectorDefinition;
